/* --- WISHLIST MANAGER --- */
if (typeof WishlistManager === 'undefined') {
  class WishlistManager {
    constructor() {
      this.storageKey = 'shopify_wishlist';
      this.items = [];
      this.init();
    }

    init() {
      this.loadWishlist();
      // Use a single delegated listener to prevent errors if buttons are missing
      document.addEventListener('click', (e) => {
        const wishlistBtn = e.target.closest('[data-wishlist]');
        if (wishlistBtn) {
          e.preventDefault();
          e.stopPropagation();
          this.toggle(wishlistBtn);
        }
      });
      this.updateAllButtons();
    }

    loadWishlist() {
      try {
        const stored = localStorage.getItem(this.storageKey);
        this.items = stored ? JSON.parse(stored) : [];
      } catch (e) {
        this.items = [];
      }
    }

    saveWishlist() {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(this.items));
        // Dispatch event for other components to listen to
        window.dispatchEvent(new CustomEvent('wishlist:updated', {
          detail: { wishlist: this.items }
        }));
      } catch { }
    }

    isInWishlist(productId) {
      return this.items.some((item) => item.id === productId);
    }

    toggle(button) {
      const productId = button.dataset.productId;
      const productTitle = button.dataset.productTitle;
      const productHandle = button.dataset.productHandle;
      if (this.isInWishlist(productId)) {
        this.remove(productId, button);
      } else {
        this.add(productId, productTitle, productHandle, button);
      }
    }

    add(productId, productTitle, productHandle, button) {
      this.items.push({
        id: productId,
        title: productTitle,
        handle: productHandle,
        addedAt: new Date().toISOString(),
      });
      this.saveWishlist();
      button.classList.add('is-active');
      this.showNotification(`Added to Wishlist!`);

      // GA4 tracking for add_to_wishlist event
      try {
        const itemSku = button.dataset.productSku || productId;
        const itemPrice = parseFloat(button.dataset.productPrice || 0);
        const itemVendor = button.dataset.productVendor || '';
        const itemType = button.dataset.productType || '';
        const itemVariant = button.dataset.productVariant || '';
        const discount = parseFloat(button.dataset.productDiscount || 0);
        const affiliation = button.dataset.productAffiliation || '';
        const currency = button.dataset.currency || window.Shopify?.currency?.active || 'INR';

        const tracker = window.gtag || function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(arguments);
        };

        tracker("event", "add_to_wishlist", {
          currency: currency,
          value: itemPrice,
          items: [
            {
              item_id: itemSku,
              item_name: productTitle,
              affiliation: affiliation,
              discount: discount,
              item_brand: itemVendor,
              item_category: itemType,
              item_variant: itemVariant,
              price: itemPrice,
              quantity: 1
            }
          ]
        });
      } catch (e) {
        console.error('Error tracking add_to_wishlist event:', e);
      }
    }

    remove(productId, button) {
      const product = this.items.find((item) => item.id === productId);
      this.items = this.items.filter((item) => item.id !== productId);
      this.saveWishlist();
      button.classList.remove('is-active');
      if (product) this.showNotification(`Removed from Wishlist`);
    }

    updateAllButtons() {
      document.querySelectorAll('[data-wishlist]').forEach((button) => {
        if (this.isInWishlist(button.dataset.productId)) button.classList.add('is-active');
      });
    }

    showNotification(message) {
      const existing = document.querySelector('.wishlist-notification');
      if (existing) existing.remove();
      const note = document.createElement('div');
      note.className = 'wishlist-notification';
      note.textContent = message;
      document.body.appendChild(note);
      setTimeout(() => note.classList.add('show'), 10);
      setTimeout(() => {
        note.classList.remove('show');
        setTimeout(() => note.remove(), 300);
      }, 3000);
    }
  }
  window.WishlistManager = WishlistManager;
}

/* --- PRODUCT CARD SLIDER --- */
if (typeof ProductCardSlider === 'undefined') {
  class ProductCardSlider {
    constructor(el) {
      this.slider = el;
      this.slides = el.querySelectorAll('.product-card__slide');
      this.dots = el.querySelectorAll('.product-card__dot');
      this.prevBtn = el.querySelector('[data-slider-prev]');
      this.nextBtn = el.querySelector('[data-slider-next]');
      this.current = 0;
      this.touchStartX = 0;
      this.touchEndX = 0;
      if (this.slides.length > 0) this.init();
    }

    init() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.prev();
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.next();
        });
      }
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.goTo(i);
        });
      });

      this.slider.addEventListener(
        'touchstart',
        (e) => {
          this.touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true }
      );

      this.slider.addEventListener(
        'touchend',
        (e) => {
          this.touchEndX = e.changedTouches[0].screenX;
          this.handleSwipe();
        },
        { passive: true }
      );
    }

    handleSwipe() {
      const diff = this.touchEndX - this.touchStartX;
      if (Math.abs(diff) < 40) return;
      diff < 0 ? this.next() : this.prev();
    }

    goTo(index) {
      this.slides[this.current].classList.remove('active');
      if (this.dots[this.current]) this.dots[this.current].classList.remove('active');
      this.current = index;
      this.slides[this.current].classList.add('active');
      if (this.dots[this.current]) this.dots[this.current].classList.add('active');
    }

    next() {
      this.goTo((this.current + 1) % this.slides.length);
    }
    prev() {
      this.goTo((this.current - 1 + this.slides.length) % this.slides.length);
    }
  }
  window.ProductCardSlider = ProductCardSlider;
}

/* --- INITIALIZATION --- */
function initProductCards() {
  // Initialize Wishlist once
  if (!window.wishlistInstance) {
    window.wishlistInstance = new window.WishlistManager();
  }

  // Initialize Sliders
  document.querySelectorAll('[data-slider]:not(.slider-initialized)').forEach((slider) => {
    try {
      new window.ProductCardSlider(slider);
      slider.classList.add('slider-initialized');
    } catch (e) {
      console.error('Error initializing product card slider:', e);
    }
  });
}

// Run on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductCards);
} else {
  initProductCards();
}

// Shopify Theme Editor Support (runs when sections are customized)
document.addEventListener('shopify:section:load', initProductCards);

// Support for infinite scroll and dynamic content loading
if (!window.productCardObserver) {
  window.productCardObserver = new MutationObserver(() => {
    initProductCards();
  });

  window.productCardObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
